import React from 'react';
import styled from 'styled-components';

interface IProps {
  variant?: 'filled' | 'outlined';
  label?: string;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  [key: string]: any;
  wrapperStyle?: React.CSSProperties;
  /* Select 너비 (기본값: outlined일 때 148px, 그 외 100%) */
  width?: string | number;
}

const SelectWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

const Label = styled.label`
  position: absolute;
  top: -19px;
  left: 0px;
  z-index: 1;
  white-space: nowrap;
  color: #545454;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const StyledSelect = styled.select<IProps>`
  ${({ variant, width }) => {
    switch (variant) {
      case 'outlined':
        return `
          display: flex;
          width: ${width ? (typeof width === 'number' ? `${width}px` : width) : '148px'};
          height: 35px;
          padding: 2px 14px;
          justify-content: space-between;
          align-items: center;
          border-radius: 4px;
          border: 1px solid #DDD;
          background: #FFF;
          color: #333;
          font-family: Pretendard;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 31px;
        `;
      default:
        return `
          width: ${width ? (typeof width === 'number' ? `${width}px` : width) : '100%'};
          height: 35px;
          background: none;
          border: none;
          border-bottom: 1px solid black;
          padding: 5px 8px;
        `;
    }
  }}

  cursor: pointer;
`;

const Select = React.forwardRef<HTMLSelectElement, IProps>(({ label, variant, children, ...props }, ref) => {
  return (
    <SelectWrapper style={props.wrapperStyle}>
      {label && <Label>{label}</Label>}
      <StyledSelect ref={ref} variant={variant} {...props}>
        {children}
      </StyledSelect>
    </SelectWrapper>
  );
});

Select.displayName = 'Select';

export default Select;
